import { gql } from "@apollo/client";
import { COMPANY_FRAGMENT } from "./getCompanies";

export const GET_AVAILABLE_TEMPLATES = gql`
    ${COMPANY_FRAGMENT}
    query GetAvailableTemplates {
        availableProcessTemplates {
            companySysId
            processId
            name
            description
            indexType
            instructions {
                instructionId
                projectId
                companySysId
                projectKey
                alias
                display
                precondition
                dependsOn
                userInputs
            }
            outputs
            processInputs
        }
        companies {
            ...companiesFragment
        }
    }
`;


